import { render } from "./ConfigurationAddCategoryButton.vue?vue&type=template&id=4a8913b4"
import script from "./ConfigurationAddCategoryButton.vue?vue&type=script&lang=js"
export * from "./ConfigurationAddCategoryButton.vue?vue&type=script&lang=js"

import exportComponent from "/home/projects/cc-gastro/htdocs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/ConfigurationAddCategoryButton.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4a8913b4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4a8913b4', __exports__)) {
    console.log('reload')
    api.reload('4a8913b4', __exports__)
  }
  
  module.hot.accept("./ConfigurationAddCategoryButton.vue?vue&type=template&id=4a8913b4", () => {
    console.log('re-render')
    api.rerender('4a8913b4', render)
  })

}


export default __exports__